import React from 'react'
import { useSelector } from 'react-redux'
import GameView from './components/game-view'
import { getGrid, getPlayers } from './gameSlice'
import NewGameForm from './NewGameForm'
import styles from './GameOverContainer.module.css'

export default function GameOverContainer() {
    const players = useSelector(getPlayers)
    const grid = useSelector(getGrid)

    return (
        <GameView
            players={players}
            grid={grid}
            controls={<GameOverControls />}
        />
    )
}

const GameOverControls = () => {
    return (
        <div className={styles.gameOverControls}>
            <p><strong>Game over.</strong> Create a new game to keep playing.</p>
            <NewGameForm />
        </div>
    )
}